import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import api, { normalize } from '../services/api';
import { saveToken } from '../services/Token';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const [respostaLogin, setRespostaLogin] = useState(null);
  const [empresasParaEscolha, setEmpresasParaEscolha] = useState(null);

  const finalizarLogin = (userData) => {
    if (!userData?.jwtToken) {
      setErro('Resposta de login sem token.');
      return;
    }
    saveToken(userData.jwtToken);
    login(userData);
    navigate('/', { replace: true });
  };

  const autenticar = async () => {
    setErro('');

    if (!email || !senha) {
      setErro('Informe email e senha.');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/accounts/authenticate-with-empresas', {
        email,
        password: senha,
      });

      const data = normalize(response.data);
      const empresas = data.empresasVinculadas || [];

      if (empresas.length > 1 && !data.empresaSelecionadaId) {
        setRespostaLogin(data);
        setEmpresasParaEscolha(empresas);
      } else {
        finalizarLogin(data);
      }
    } catch (error) {
      setErro(error.response?.data?.message || 'Erro ao autenticar. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  const escolherEmpresa = (empresa) => {
    finalizarLogin({
      ...respostaLogin,
      empresaSelecionadaId: empresa.id,
      empresaSelecionada: empresa,
    });
    setEmpresasParaEscolha(null);
  };

  return (
    <main className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <img
            className="login-logo"
            src={`${process.env.PUBLIC_URL || ''}/brand/logo-nfseapp.png`}
            alt="NFSeApp"
          />
        </div>
        <p className="login-subtitle">Emissão de Nota Fiscal de Serviço Eletrônica</p>

        <label className="login-label" htmlFor="login-email">E-mail</label>
        <input
          id="login-email"
          className="login-input"
          type="email"
          autoComplete="username"
          placeholder="seu@email.com"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />

        <label className="login-label" htmlFor="login-senha">Senha</label>
        <input
          id="login-senha"
          className="login-input"
          type="password"
          autoComplete="current-password"
          placeholder="Sua senha"
          value={senha}
          onChange={(event) => setSenha(event.target.value)}
          onKeyDown={(event) => event.key === 'Enter' && autenticar()}
        />

        {erro && <p className="login-erro">{erro}</p>}

        <button type="button" className="login-btn" onClick={autenticar} disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </div>

      <Dialog
        header="Selecione a empresa"
        visible={!!empresasParaEscolha}
        onHide={() => setEmpresasParaEscolha(null)}
        style={{ width: '380px' }}
      >
        <div className="login-empresas-lista">
          {(empresasParaEscolha || []).map((empresa) => (
            <Button
              key={empresa.id}
              label={empresa.fantasia || empresa.razaosocial}
              icon="pi pi-building"
              className="p-button-outlined login-empresa-btn"
              onClick={() => escolherEmpresa(empresa)}
            />
          ))}
        </div>
      </Dialog>
    </main>
  );
}

export default Login;
